import { ComponentProps } from 'react'
import { Menu } from '@highlight/ui'

interface ToastOptionsItemProps extends ComponentProps<typeof Menu.Item> {}

export function ToastOptionsItem(props: ToastOptionsItemProps) {
  return <Menu.Item {...props} />
}
